import type { SchemaAST } from 'effect';

import { Effect, Schema } from 'effect';

/**
 * A `Schema.Struct` whose `_tag` is synthesized when the input omits it.
 *
 * **Why not `Schema.TaggedStruct`:** the built-in requires `_tag` to be present
 * in the input on both decode and encode. The schemas built here decode the
 * backend's filter payloads, which carry no `_tag` at all. The tag is this
 * client's own discriminator, added so the attributes form a tagged union.
 * `Schema.withDecodingDefaultKey` supplies it for a missing key and leaves the
 * Type side required, so `Match.tag` still narrows.
 *
 * `Schema.tag` covers the constructor side: it is `Schema.Literal` combined
 * with `Schema.withConstructorDefault`, so `make` may omit the tag too.
 */
export const TaggedStructFromUntagged = <
  Tag extends SchemaAST.LiteralValue,
  Fields extends Schema.Struct.Fields,
>(
  tag: Tag,
  fields: Fields
) =>
  Schema.Struct({
    _tag: Schema.tag(tag).pipe(Schema.withDecodingDefaultKey(Effect.succeed(tag))),
    ...fields,
  });
